import 'rxjs';
import {Subject, Subscription} from 'rxjs';

export class NbSortingService {
  private events = new Subject();
  subscribe (next,error?,complete?):Subscription {
    return this.events.subscribe(next,error,complete);
  }
  next (event) {
    this.events.next(event);
  }
}
